const stats = [
  {
    value: "200,000+",
    label: "professionals connected to the wider Utiva ecosystem",
  },
  { value: "19", label: "countries represented across the talent community" },
  { value: "800+", label: "employers connected to Utiva's hiring ecosystem" },
  {
    value: "Live + practical",
    label: "learning built around instruction, projects and assessment",
  },
];

const HomeTrustStatsSection = () => {
  return (
    <section className="bg-secondary py-10 px-4">
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat, index) => (
          <div
            key={stat.value}
            className={`min-h-[130px] px-6 py-4 ${
              index !== 0 ? "sm:border-l border-primary/20" : ""
            }`}
          >
            <span className="text-primary font-poppins tracking-[-0.04em] text-3xl font-extrabold block mb-2">
              {stat.value}
            </span>
            <p className="text-[#5c481a] font-poppins text-sm leading-[1.65] m-0">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeTrustStatsSection;
